import React from "react";

type PlayerTraits = {
  pitcher?: boolean | null;
  catcher?: boolean | null;
  battingHandedness?: string | null;
  throwingHandedness?: string | null;
};

interface PlayerTraitBadgesProps {
  player: PlayerTraits;
  compact?: boolean;
}

const normalizeBattingHand = (value?: string | null) => {
  const normalized = (value ?? "").trim().toUpperCase();
  return normalized === "L" || normalized === "R" || normalized === "B" ? normalized : "";
};

const normalizeThrowingHand = (value?: string | null) => {
  const normalized = (value ?? "").trim().toUpperCase();
  return normalized === "L" || normalized === "R" ? normalized : "";
};

const PlayerTraitBadges: React.FC<PlayerTraitBadgesProps> = ({ player, compact = false }) => {
  const battingHand = normalizeBattingHand(player.battingHandedness);
  const throwingHand = normalizeThrowingHand(player.throwingHandedness);
  const traits: Array<{ key: string; label: string }> = [];

  if (player.pitcher) {
    traits.push({ key: "pitcher", label: "P" });
  }
  if (player.catcher) {
    traits.push({ key: "catcher", label: "C" });
  }
  if (battingHand) {
    traits.push({ key: "bat", label: `Bat ${battingHand}` });
  }
  if (throwingHand) {
    traits.push({ key: "throw", label: `Throw ${throwingHand}` });
  }

  if (traits.length === 0) {
    return null;
  }

  return (
    <div className="bubble-pill-wrap" style={compact ? { gap: "0.3rem" } : undefined}>
      {traits.map((trait) => (
        <span
          key={trait.key}
          className="bubble-pill"
          style={compact ? { fontSize: "0.72rem", padding: "0.18rem 0.46rem" } : undefined}
        >
          {trait.label}
        </span>
      ))}
    </div>
  );
};

export default PlayerTraitBadges;
